// Copyright (c) 2025 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import RgaDomainValues from '../../../shared/rga-domain-values/state/rga-domain-values';
import RgaSearchForm from './rga-search-form';
import RgaSearchModel from '../../state/rga-search-model';
import SearchByDropDown from '../../state/search-by-dropdown';

const AdvanceSearchAccordion = props => {

    const body = (
        <RgaSearchForm
            actions={props.actions}
            rgaDomainValues={props.shared.rgaDomainValues}
            rgaSearchModel={props.search.rgaSearchModel}
            rgaSearchSelectedDomains={props.search.rgaSearchSelectedDomains}
            searchByDropDown={props.search.searchByDropDown}
        />
    );

    const title = (
        <FormattedMessage
            id='Advance Search'
        />
    );

    return true &&
        <Accordion
            accordionId='part-request-analysis-accordion'
            body={body}
            isExpanded={true}
            secondaryHeaderNode={null}
            title={title}
        />;

};

AdvanceSearchAccordion.displayName = 'AdvanceSearchAccordion';
AdvanceSearchAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    rgaDomainValues: PropTypes.instanceOf(RgaDomainValues).isRequired,
    rgaSearchModel: PropTypes.instanceOf(RgaSearchModel).isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchByDropDown).isRequired
};

export default AdvanceSearchAccordion;



// WEBPACK FOOTER //
// ./src/rga/search/components/advance-search-rga/advance-search-accordion.js